module.exports = [{"areaCode":440000000000,"parentCode":0,"areaName":"广东省","children":[]}]


//////////////////
// WEBPACK FOOTER
// ./src/utils/area/guangdong.json
// module id = vAwK
// module chunks = 83